/*
 * @Author: XuJingXin v_xujingxin@tal.com
 * @Date: 2024-11-16 11:13:49
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @LastEditTime: 2024-12-03 21:01:39
 * @FilePath: /sea_parent_webapp/src/utils/config.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { v4 as uuidv4 } from 'uuid';
import md5 from 'md5';
import { ready, requestToken } from '@genie/sea.uni.jsbridge';
const getInfo = () => {
    return new Promise((resolve, reject) => {
        try {
            ready(() => {
                requestToken({
                    onSuccess: (res: any) => {
                        if (!res) reject('token is null');
                        const isAndroid = judgmentUa('android');
                        const data = isAndroid ? JSON?.parse(res) : res;
                        resolve(data);
                    },
                    onFail: (err) => {
                        reject(err);
                    },
                });
            });
        } catch (error) {
            reject(error);
        }
    });
};

export const getDeviceTalId = async () => {
    const data: any = await getInfo();
    return data?.talId;
};

export const generateBaseHeader = async () => {
    const headers: any = {};
    const data: any = await getInfo();
    console.log('===data', data, typeof data);
    const uuid = uuidv4();
    const timestamp = Math.floor(Date.now() / 1000);
    const Authorization = data?.token;
    const sn = '70201D0B4A0900172';
    const secret = Authorization?.slice(data?.startIndex, data?.endIndex);
    const sign = md5(`${timestamp}${uuid}${secret}`).toLowerCase();
    headers['X-Tal-Nonce'] = uuid;
    headers['X-Tal-Timestamp'] = timestamp;
    headers['X-Tal-Sn'] = sn;
    headers['X-Tal-Sign'] = sign;
    headers['X-Tal-App-Version'] = data?.version;
    headers['X-Tal-DeviceId'] = '00000000-2eae-ee33-ffff-ffffef05ac4';
    headers['X-AppId'] = '1005384';
    headers.Authorization = Authorization;
    headers['X-Tal-OS'] = data?.os;
    headers['X-Tal-App-VersionCode'] = data?.versionCode;
    headers['X-Tal-App-VersionName'] = data?.version;
    headers['X-Tal-PackageName'] = data?.applicationId;
    return headers;
};
// 判断ua中是否包含数据
export const judgmentUa = (data) => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes(data);
};

// 查看浏览器版本信息
export const getBrowserVersion = () => {
    var userAgent = navigator.userAgent,
        tem,
        matchTest =
            userAgent.match(
                /(chrome|safari|firefox|edge|opera|opr|msie|trident(?=\/))\/?\s*(\d+)/i
            ) || [];
    if (/trident/i.test(matchTest[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
        tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2]
        ? [matchTest[1], matchTest[2]]
        : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
};
